import React from 'react';

// slices: [{ label, value: number|bigint, color }]
const DonutChart = ({ slices = [], size = 220, thickness = 22, centerLabel, centerValue }) => {
  const vals = slices.map((s) => Number(s.value || 0));
  const total = vals.reduce((a, b) => a + b, 0);
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  const cx = size / 2, cy = size / 2;

  let offset = 0;
  const arcs = slices.map((s, i) => {
    const v = vals[i];
    const frac = total > 0 ? v / total : 0;
    const len = circumference * frac;
    const dash = `${len} ${circumference - len}`;
    const arc = (
      <circle
        key={i}
        cx={cx} cy={cy} r={radius}
        fill="none"
        stroke={s.color}
        strokeWidth={thickness}
        strokeDasharray={dash}
        strokeDashoffset={-offset}
        strokeLinecap="butt"
        style={{ transition: 'stroke-dasharray 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }}
      />
    );
    offset += len;
    return arc;
  });

  return (
    <div className="donut-wrap">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={cx} cy={cy} r={radius} fill="none" stroke="rgba(0, 255, 157, 0.05)" strokeWidth={thickness} />
        {total > 0 && arcs}
      </svg>
      <div className="donut-center">
        {centerLabel && <div className="donut-center-label">{centerLabel}</div>}
        {centerValue && <div className="donut-center-value">{centerValue}</div>}
      </div>
    </div>
  );
};

export default DonutChart;
